<template>
  <div class="app-container">
    <div ref="tableContainer" class="complete-order-pick-list">
      <el-row class="page-buttons">
        <span style="font-size:20px;font-weight:bold;">{{ orderPickListHeader }}</span>
        <editor-button action="cancel" style="float:right" @click="close" />
        <editor-button
          v-show="selectedPickListID !== null"
          :disabled="!changesMade"
          :icon-only="false"
          :loading="loading"
          button-translation="orderPick.processPickedItems"
          action="primary"
          style="float:right;margin-right:10px"
          @click="saveSelection()"
        />
        <editor-button
          v-show="selectedPickListID !== null"
          :icon-only="false"
          button-translation="common.downloadExcel"
          action="primary"
          style="float:right"
          @click="downloadOrderPickList()"
        />
        <span style="width:20%;float:right;padding-bottom:10px">
          <el-autocomplete
            v-show="selectedPickListID !== null"
            v-model="addFabricInput"
            style="width:100%"
            :fetch-suggestions="getFabricSuggestions"
            :placeholder="$t('orderPick.addFabric')"
            @select="handleFabricSelected"
          />
        </span>
        <editor-button
          :icon-only="false"
          :loading="loading"
          button-translation="orderPick.prefill"
          action="primary"
          style="float:right;margin-right:10px"
          @click="prefill()"
        />
        <el-collapse-transition>
          <el-alert v-if="errorMsg" :title="errorMsg" type="error" :closable="false" />
        </el-collapse-transition>
      </el-row>
      <pagination
        v-if="numberOfItems > 0"
        :total="numberOfItems"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="paginateList"
      />
      <el-table
        ref="orderPickList"
        v-loading="loading"
        :data="paginatedItems"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="650"
      >
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input
              v-model="search['productCode']"
              :disabled="changesMade"
              class="search"
              size="mini"
              :placeholder="$t('orderPick.productCode')"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('orderPick.productCode')" width="130">
            <template slot-scope="scope">
              <span>{{ scope.row['productCode'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}">
            <el-input
              v-model="search['productDescription']"
              :disabled="changesMade"
              class="search"
              size="mini"
              :placeholder="$t('orderPick.productDescription')"
              clearable
              prefix-icon="el-icon-search"
            />
          </template>
          <el-table-column :label="$t('orderPick.productDescription')" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row['productDescription'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="$t('orderPick.widthInCm')" width="70">
            <template slot-scope="scope">
              <span>{{ scope.row['widthInCm'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="$t('orderPick.yarnNumber')" width="70">
            <template slot-scope="scope">
              <span>{{ scope.row['yarnNumber'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="workshopStockLocationName" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row['workshopStockPositionCode'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="distributionCenterStockLocationName" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row['distributionCenterStockPositionCode'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="$t('orderPick.neededMeters')" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row['neededMeters'] }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="$t('orderPick.pickedMeters')" width="110">
            <template slot-scope="{ row }">
              <MDinput
                v-model="row.pickedMeters"
                type="number"
                :precision="2"
                :min="0"
                placeholder="common.fillInANumber"
                @input="handleInputPickedMeters(row, $event)"
              />
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="$t('orderPick.pickedNumberOfRolls')" width="110">
            <template slot-scope="{ row }">
              <MDinput
                v-model="row.pickedNumberOfRolls"
                type="number"
                :precision="0"
                :min="0"
                placeholder="common.fillInANumber"
                @input="handleInputPickedNumberOfRolls(row, $event)"
              />
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>
          <el-table-column :label="$t('orderPick.comments')">
            <template slot-scope="{ row }">
              <MDinput v-model="row.comments" type="text" @input="handleInputComments(row, $event)" />
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import EditorButton from '@/components/crud/EditorButton';
import MDinput from '@/components/MDinput';
import { closeCurrentTag } from '@/utils/tags';
import {
  ConvertMillimetersToMeters,
  ConvertMetersToMillimeters,
  ConvertMillimetersToCentimeters
} from '@/utils/converters';
import { ForceFileDownload } from '@/utils/general';

const debounce = require('lodash.debounce');

export default {
  name: 'CompleteOrderPickList',
  components: {
    Pagination,
    EditorButton,
    MDinput
  },
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      errorMsg: '',
      orderPickListWeek: '',
      orderPickListWorkshop: '',
      items: [],
      filteredItems: [],
      paginatedItems: [],
      numberOfItems: 0,
      loading: false,
      selectedPickListID: null,
      workshopStockLocationName: null,
      distributionCenterStockLocationName: null,
      listQuery: {
        limit: 50,
        page: 1
      },
      search: {},
      selectedFabric: {},
      fabricSuggestions: [],
      addFabricInput: '',
      orderPickListHeader: ''
    };
  },
  computed: {
    changesMade() {
      return this.items.some(e => e.isChanged);
    },
    listParams() {
      const params = {};
      params.query = { ...this.filters, ...this.listQuery };
      if (Object.keys(this.search).length > 0) {
        params.query = { ...params.query, ...this.search };
      }
      return params;
    }
  },
  watch: {
    items: {
      handler: function(value) {
        this.filterAllItems();
        this.numberOfItems = this.filteredItems.length;
        this.paginateList({ limit: this.listQuery.limit, page: 1 });
        if (this.items.length) {
          this.workshopStockLocationName =
            this.$i18n.t('orderPick.location') + ' ' + this.items[0].workshopStockLocationName;
          this.distributionCenterStockLocationName =
            this.$i18n.t('orderPick.location') + ' ' + this.items[0].distributionCenterStockLocationName;
        }
      }
    },
    search: {
      deep: true,
      handler: function(value) {
        this.listQuery.page = 1;
        this.filterAllItems();
        this.numberOfItems = this.filteredItems.length;
        this.paginateList({ limit: this.listQuery.limit, page: 1 });
      }
    }
  },
  created() {
    this.debouncedUpdateSearch = debounce(this.refreshList, 500);
    this.handlePickListChange(+this.$route.params.id);
  },
  methods: {
    getFabricSuggestions(queryString, cb) {
      if (this.fabricSuggestions.length === 0) {
        this.$store
          .dispatch('orderPickList/getOrderPickListFabricSuggestions', {
            orderPickListID: this.selectedPickListID
          })
          .then(data => {
            const suggestions = data.map(i => {
              return { id: i.productID, value: i.product.description + ', ' + i.product.domainProductCode };
            });
            this.fabricSuggestions = suggestions;
            const result = suggestions.filter(s => s.value.toLowerCase().includes(queryString));
            cb(result.slice(0, 25));
          });
      } else {
        const result = this.fabricSuggestions.filter(s => s.value.toLowerCase().includes(queryString));
        cb(result.slice(0, 25));
      }
    },
    handleFabricSelected(item) {
      this.$store
        .dispatch('orderPickList/addFabricToOrderPickList', {
          fabricID: item.id,
          orderPickListID: +this.selectedPickListID
        })
        .then(() => {
          this.refreshList();
          this.addFabricInput = '';
        });
    },
    prefill() {
      if (this.filteredItems) {
        this.filteredItems.forEach(item => {
          item.pickedMeters = +item.neededMeters;
          item.isChanged = true;
        });
      }
    },
    filterAllItems() {
      this.filteredItems = [...this.items];
      if (this.search.productCode && this.search.productCode.length) {
        this.filteredItems = this.filteredItems.filter(
          e => !!e.productCode && e.productCode.indexOf(this.search.productCode) !== -1
        );
      }
      if (this.search.productDescription && this.search.productDescription.length) {
        this.filteredItems = this.filteredItems.filter(
          e =>
            !!e.productDescription && e.productDescription.toLowerCase().indexOf(this.search.productDescription) !== -1
        );
      }
    },
    refreshList() {
      if (!this.selectedPickListID || this.selectedPickListID.length === 0) {
        return;
      }
      this.loading = true;

      this.$store
        .dispatch('orderPickList/getOrderPickListFabricSuggestions', {
          orderPickListID: this.selectedPickListID
        })
        .then(data => {
          this.fabricSuggestions = data.map(i => {
            return { id: i.productID, value: i.product.description + ', ' + i.product.domainProductCode };
          });
        });

      this.$store
        .dispatch('orderPickList/getOrderPickListItems', {
          orderPickListID: this.selectedPickListID
        })
        .then(data => {
          let orderPickListHeader =
            this.$i18n.t('common.week') + ' ' + data.weekNumber + ' - ' + data.domain + ', ' + data.workshopDescription;
          if (data.seriesNumbers) {
            orderPickListHeader += ', Series ' + data.seriesNumbers;
          }
          this.orderPickListHeader = orderPickListHeader;
          const items = data.orderPickListItems.map(e => {
            return {
              ...e,
              pickedMeters: ConvertMillimetersToMeters(e.pickedFabricInMm),
              neededMeters: ConvertMillimetersToMeters(e.neededFabricInMm).toFixed(2),
              widthInCm: ConvertMillimetersToCentimeters(e.actualWidthInMm),
              isChanged: false
            };
          });
          this.orderPickListWorkshop = data.workshopDescription;
          this.orderPickListWeek = data.weekNumber;
          this.items = items;
          this.numberOfItems = items.length;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    paginateList(pageInfo) {
      const startIndex = (this.listQuery.page - 1) * this.listQuery.limit;
      const endIndex = startIndex + this.listQuery.limit;
      this.paginatedItems = this.filteredItems.slice(startIndex, endIndex);
      this.listQuery.page = pageInfo.page;
    },
    close() {
      closeCurrentTag(this);
    },
    async saveSelection() {
      this.loading = true;
      this.errorMsg = '';
      const orderPicks = [];
      try {
        this.items.forEach(row => {
          if (row.isChanged) {
            let pickedMillimeters = ConvertMetersToMillimeters(row.pickedMeters);
            if (pickedMillimeters !== null) {
              pickedMillimeters = Math.ceil(pickedMillimeters);
            }
            orderPicks.push({
              lineNumber: row.lineNumber,
              pickedFabricInMm: pickedMillimeters,
              pickedNumberOfRolls: row.pickedNumberOfRolls,
              comments: row.comments
            });
          }
        });
        const orderPickListID = +this.$route.params.id;
        const dto = {
          orderPickListID: orderPickListID,
          items: orderPicks
        };
        this.$store.dispatch('orderPickList/updateOrderPickList', dto).then(() => {
          this.$store.dispatch('notify/success', { message: this.$i18n.t('common.data_updated') });
          this.refreshList();
          this.items.forEach(row => {
            row.isChanged = false;
          });
        });
      } catch (err) {
        this.errorMsg = err && (err.message || this.$i18n.t('common.error'));
      } finally {
        this.loading = false;
      }
    },
    handlePickListChange(selectedPickListID) {
      this.selectedPickListID = selectedPickListID;
      this.refreshList();
    },
    handleInputPickedMeters(row, pickedMeters) {
      row.isChanged = true;
    },
    handleInputPickedNumberOfRolls(row, pickedNumberOfRolls) {
      row.isChanged = true;
    },
    handleInputComments(row, comments) {
      row.isChanged = true;
    },
    downloadOrderPickList() {
      this.loading = true;
      this.$store
        .dispatch('orderPickList/downloadSentOrderPickList', {
          orderPicklistID: this.selectedPickListID
        })
        .then(blob => {
          const excelName = this.orderPickListWorkshop + ' OrderPick week ' + this.orderPickListWeek + '.xlsx';
          ForceFileDownload(blob, excelName);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.validation-errors {
  display: block;
  color: #f56c6c;
  text-align: left;
  top: 100%;
}

.complete-order-pick-list {
  .edit-input {
    padding-right: 100px;
  }

  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }

  .filter-cell > div {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .hide-overflow {
    .cell {
      white-space: nowrap;
    }
  }

  .search {
    .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .el-input__prefix {
      left: 0;
    }

    .el-input__suffix {
      right: 0;
    }
  }

  .search-select {
    width: 100%;

    .el-input__inner {
      padding-left: 5px;
    }

    .el-input {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .el-input__suffix {
      top: -2px;
      right: 10px;
    }
  }

  .el-table .cell {
    min-height: 3em !important;
  }

  .el-table .cell {
    word-break: break-word;
  }

  .el-table .el-table__row {
    background-color: white;
  }

  .el-table tbody tr:hover .cell {
    color: initial;
  }

  .el-table .input-hidden {
    visibility: hidden;
  }
}
</style>
